import React from 'react';
import { Row, Col, Layout } from 'antd';

import Welcome from '../Welcome/Welcome';
import RegisterForm from '../RegisterForm/RegisterForm';

import './Content.css';

export default function Content({ carrierConfig }) {
  return (
    <Layout.Content style={{ padding: '0 50px' }}>
      <Row gutter={16}>
        <Col className='gutter-row' xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
          <Welcome carrierConfig={carrierConfig} />
        </Col>
        <Col className='gutter-row' xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
          <RegisterForm carrierConfig={carrierConfig} />
        </Col>
      </Row>
    </Layout.Content>
  );
}
